// Results-count line above the cards. Pure so the dashboard panel, the
// My Courses page and their stories share one wording instead of each keeping
// a near-identical copy.

const plural = (n) => (n === 1 ? '' : 's');

export function subheaderTextFor(tab, sections = {}) {
  const { current = [], upcoming = [], transcriptToAdd = [], transcripted = [], past = [] } = sections;

  if (tab === 'current') return `Showing ${current.length} current course${plural(current.length)}`;
  if (tab === 'upcoming') return `Showing ${upcoming.length} upcoming course${plural(upcoming.length)}`;

  // Past counts every course in the tab but calls out how many are still
  // actionable, since the rest are transcripted, expired or unenrolled.
  if (tab === 'past') {
    const eligible = transcriptToAdd.length;
    const total = eligible + transcripted.length + past.length;
    const count = `Showing ${total} total result${plural(total)}`;
    if (!eligible) return count;
    return `${count}, ${eligible} ${eligible === 1 ? 'is' : 'are'} eligible to add to transcript`;
  }

  const all = current.length + upcoming.length + transcriptToAdd.length + transcripted.length + past.length;
  return `Showing ${all} course${plural(all)}`;
}
